import React from 'react';
import ImageWithFallback from './ImageWithFallback';
import './App.css';

const IndiaFlag = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>India Flag</h1>
        <p>Create the Indian flag with this patriotic coding project.</p>
        <div
          style={{
        width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/india_flag.gif" 
            alt="India Flag" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project draws the Indian flag using Python code with the correct colors and proportions.</p>
        <h2>Download</h2>
        <a href="/india_flag.py" download>Download india_flag.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to see the Indian flag being drawn.</p>
      </div>
          </div>
  );
};

export default IndiaFlag;
